import React from 'react';
import { colors } from 'styleguide';

import { IconProps } from './types';

const Profile = ({ size = 20, color = colors('neutral', 3) }: IconProps) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M13.9842 21.2689L11.6839 17.2846L13.9842 13.3003L18.5849 13.3003L20.8852 17.2846L18.5849 21.2689L13.9842 21.2689Z"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="none"
    />
    <path
      d="M4.98421 16.2689L2.68387 12.2846L4.98421 8.30028L9.58488 8.30028L11.8852 12.2846L9.58488 16.2689L4.98421 16.2689Z"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="none"
    />
    <path
      d="M13.9842 11.2689L11.6839 7.28458L13.9842 3.30028L18.5849 3.30028L20.8852 7.28458L18.5849 11.2689L13.9842 11.2689Z"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="none"
    />
  </svg>
);

export default Profile;
